// // 国家及其电话区号列表
let COUNTRY_CODE = [
  {"eng_name":"Andorra","name":"安道尔","abs":"AD","code":"376"},
  {"eng_name":"United Arab Emirates","name":"阿拉伯联合酋长国","abs":"AE","code":"971"},
  {"eng_name":"Afghanistan","name":"阿富汗","abs":"AF","code":"93"},
  {"eng_name":"Antigua and Barbuda","name":"安提瓜和巴布达","abs":"AG","code":"1268"},
  {"eng_name":"Anguilla","name":"安圭拉","abs":"AI","code":"1264"},
  {"eng_name":"Albania","name":"阿尔巴尼亚","abs":"AL","code":"355"},
  {"eng_name":"Armenia","name":"亚美尼亚","abs":"AM","code":"374"},
  {"eng_name":"Angola","name":"安哥拉","abs":"AO","code":"244"},
  {"eng_name":"Argentina","name":"阿根廷","abs":"AR","code":"54"},
  {"eng_name":"American Samoa","name":"美属萨摩亚","abs":"AS","code":"1684"},
  {"eng_name":"Austria","name":"奥地利","abs":"AT","code":"43"},
  {"eng_name":"Australia","name":"澳大利亚","abs":"AU","code":"61"},
  {"eng_name":"Aruba","name":"阿鲁巴","abs":"AW","code":"297"},
  {"eng_name":"Azerbaijan","name":"阿塞拜疆","abs":"AZ","code":"994"},
  {"eng_name":"Bosniaand Herzegovina","name":"波斯尼亚和黑塞哥维那","abs":"BA","code":"387"},
  {"eng_name":"Barbados","name":"巴巴多斯","abs":"BB","code":"1246"},
  {"eng_name":"Bangladesh","name":"孟加拉国","abs":"BD","code":"880"},
  {"eng_name":"Belgium","name":"比利时","abs":"BE","code":"32"},
  {"eng_name":"Burkina Faso","name":"布基纳法索","abs":"BF","code":"226"},
  {"eng_name":"Bulgaria","name":"保加利亚","abs":"BG","code":"359"},
  {"eng_name":"Bahrain","name":"巴林","abs":"BH","code":"973"},
  {"eng_name":"Burundi","name":"布隆迪","abs":"BI","code":"257"},
  {"eng_name":"Benin","name":"贝宁","abs":"BJ","code":"229"},
  {"eng_name":"Bermuda","name":"百慕大群岛","abs":"BM","code":"1441"},
  {"eng_name":"Brunei","name":"文莱","abs":"BN","code":"673"},
  {"eng_name":"Bolivia","name":"玻利维亚","abs":"BO","code":"591"},
  {"eng_name":"Caribisch Nederland","name":"荷兰加勒比","abs":"BQ","code":"599"},
  {"eng_name":"Brazil","name":"巴西","abs":"BR","code":"55"},
  {"eng_name":"Bahamas","name":"巴哈马","abs":"BS","code":"1242"},
  {"eng_name":"Bhutan","name":"不丹","abs":"BT","code":"975"},
  {"eng_name":"Botswana","name":"博茨瓦纳","abs":"BW","code":"267"},
  {"eng_name":"Belarus","name":"白俄罗斯","abs":"BY","code":"375"},
  {"eng_name":"Belize","name":"伯利兹","abs":"BZ","code":"501"},
  {"eng_name":"Canada","name":"加拿大","abs":"CA","code":"1"},
  {"eng_name":"Democratic Republic of theCongo","name":"刚果民主共和国","abs":"CD","code":"243"},
  {"eng_name":"Central African Republic","name":"中非共和国","abs":"CF","code":"236"},
  {"eng_name":"Republic Of The Congo","name":"刚果共和国","abs":"CG","code":"242"},
  {"eng_name":"Switzerland","name":"瑞士","abs":"CH","code":"41"},
  {"eng_name":"Ivory Coast","name":"象牙海岸","abs":"CI","code":"225"},
  {"eng_name":"Cook Islands","name":"库克群岛","abs":"CK","code":"682"},
  {"eng_name":"Chile","name":"智利","abs":"CL","code":"56"},
  {"eng_name":"Cameroon","name":"喀麦隆","abs":"CM","code":"237"},
  {"eng_name":"Colombia","name":"哥伦比亚","abs":"CO","code":"57"},
  {"eng_name":"CostaRica","name":"哥斯达黎加","abs":"CR","code":"506"},
  {"eng_name":"Cape Verde","name":"开普","abs":"CV","code":"238"},
  {"eng_name":"Curacao","name":"库拉索","abs":"CW","code":"599"},
  {"eng_name":"Cyprus","name":"塞浦路斯","abs":"CY","code":"357"},
  {"eng_name":"Czech","name":"捷克","abs":"CZ","code":"420"},
  {"eng_name":"Germany","name":"德国","abs":"DE","code":"49"},
  {"eng_name":"Djibouti","name":"吉布提","abs":"DJ","code":"253"},
  {"eng_name":"Denmark","name":"丹麦","abs":"DK","code":"45"},
  {"eng_name":"Dominica","name":"多米尼加","abs":"DM","code":"1767"},
  {"eng_name":"dominican republic","name":"多米尼加共和国","abs":"DO","code":"1809"},
  {"eng_name":"Algeria","name":"阿尔及利亚","abs":"DZ","code":"213"},
  {"eng_name":"Ecuador","name":"厄瓜多尔","abs":"EC","code":"593"},
  {"eng_name":"Estonia","name":"爱沙尼亚","abs":"EE","code":"372"},
  {"eng_name":"Egypt","name":"埃及","abs":"EG","code":"20"},
  {"eng_name":"Eritrea","name":"厄立特里亚","abs":"ER","code":"291"},
  {"eng_name":"Spain","name":"西班牙","abs":"ES","code":"34"},
  {"eng_name":"Ethiopia","name":"埃塞俄比亚","abs":"ET","code":"251"},
  {"eng_name":"Finland","name":"芬兰","abs":"FI","code":"358"},
  {"eng_name":"Fiji","name":"斐济","abs":"FJ","code":"679"},
  {"eng_name":"Micronesia","name":"密克罗尼西亚","abs":"FM","code":"691"},
  {"eng_name":"Faroe Islands","name":"法罗群岛","abs":"FO","code":"298"},
  {"eng_name":"France","name":"法国","abs":"FR","code":"33"},
  {"eng_name":"Gabon","name":"加蓬","abs":"GA","code":"241"},
  {"eng_name":"United Kingdom","name":"英国","abs":"GB","code":"44"},
  {"eng_name":"Grenada","name":"格林纳达","abs":"GD","code":"1473"},
  {"eng_name":"Georgia","name":"格鲁吉亚","abs":"GE","code":"995"},
  {"eng_name":"French Guiana","name":"法属圭亚那","abs":"GF","code":"594"},
  {"eng_name":"Ghana","name":"加纳","abs":"GH","code":"233"},
  {"eng_name":"Gibraltar","name":"直布罗陀","abs":"GI","code":"350"},
  {"eng_name":"Greenland","name":"格陵兰岛","abs":"GL","code":"299"},
  {"eng_name":"Gambia","name":"冈比亚","abs":"GM","code":"220"},
  {"eng_name":"Guinea","name":"几内亚","abs":"GN","code":"224"},
  {"eng_name":"Guadeloupe","name":"瓜德罗普岛","abs":"GP","code":"590"},
  {"eng_name":"Equatorial Guinea","name":"赤道几内亚","abs":"GQ","code":"240"},
  {"eng_name":"Greece","name":"希腊","abs":"GR","code":"30"},
  {"eng_name":"Guatemala","name":"瓜地马拉","abs":"GT","code":"502"},
  {"eng_name":"Guam","name":"关岛","abs":"GU","code":"1671"},
  {"eng_name":"Guinea-Bissau","name":"几内亚比绍共和国","abs":"GW","code":"245"},
  {"eng_name":"Guyana","name":"圭亚那","abs":"GY","code":"592"},
  {"eng_name":"Hong Kong","name":"中国香港","abs":"HK","code":"852"},
  {"eng_name":"Honduras","name":"洪都拉斯","abs":"HN","code":"504"},
  {"eng_name":"Croatia","name":"克罗地亚","abs":"HR","code":"385"},
  {"eng_name":"Haiti","name":"海地","abs":"HT","code":"509"},
  {"eng_name":"Hungary","name":"匈牙利","abs":"HU","code":"36"},
  {"eng_name":"Indonesia","name":"印度尼西亚","abs":"ID","code":"62"},
  {"eng_name":"Ireland","name":"爱尔兰","abs":"IE","code":"353"},
  {"eng_name":"Israel","name":"以色列","abs":"IL","code":"972"},
  {"eng_name":"India","name":"印度","abs":"IN","code":"91"},
  {"eng_name":"Iraq","name":"伊拉克","abs":"IQ","code":"964"},
  {"eng_name":"Iceland","name":"冰岛","abs":"IS","code":"354"},
  {"eng_name":"Italy","name":"意大利","abs":"IT","code":"39"},
  {"eng_name":"Jamaica","name":"牙买加","abs":"JM","code":"1876"},
  {"eng_name":"Jordan","name":"约旦","abs":"JO","code":"962"},
  {"eng_name":"Japan","name":"日本","abs":"JP","code":"81"},
  {"eng_name":"Kenya","name":"肯尼亚","abs":"KE","code":"254"},
  {"eng_name":"Kyrgyzstan","name":"吉尔吉斯斯坦","abs":"KG","code":"996"},
  {"eng_name":"Cambodia","name":"柬埔寨","abs":"KH","code":"855"},
  {"eng_name":"Kiribati","name":"基里巴斯","abs":"KI","code":"686"},
  {"eng_name":"Comoros","name":"科摩罗","abs":"KM","code":"269"},
  {"eng_name":"Saint Kitts and Nevis","name":"圣基茨和尼维斯","abs":"KN","code":"1869"},
  {"eng_name":"South Korea","name":"韩国","abs":"KR","code":"82"},
  {"eng_name":"Kuwait","name":"科威特","abs":"KW","code":"965"},
  {"eng_name":"Cayman Islands","name":"开曼群岛","abs":"KY","code":"1345"},
  {"eng_name":"Kazakhstan","name":"哈萨克斯坦","abs":"KZ","code":"7"},
  {"eng_name":"Laos","name":"老挝","abs":"LA","code":"856"},
  {"eng_name":"Lebanon","name":"黎巴嫩","abs":"LB","code":"961"},
  {"eng_name":"Saint Lucia","name":"圣露西亚","abs":"LC","code":"1758"},
  {"eng_name":"Liechtenstein","name":"列支敦士登","abs":"LI","code":"423"},
  {"eng_name":"Sri Lanka","name":"斯里兰卡","abs":"LK","code":"94"},
  {"eng_name":"Liberia","name":"利比里亚","abs":"LR","code":"231"},
  {"eng_name":"Lesotho","name":"莱索托","abs":"LS","code":"266"},
  {"eng_name":"Lithuania","name":"立陶宛","abs":"LT","code":"370"},
  {"eng_name":"Luxembourg","name":"卢森堡","abs":"LU","code":"352"},
  {"eng_name":"Latvia","name":"拉脱维亚","abs":"LV","code":"371"},
  {"eng_name":"Libya","name":"利比亚","abs":"LY","code":"218"},
  {"eng_name":"Morocco","name":"摩洛哥","abs":"MA","code":"212"},
  {"eng_name":"Monaco","name":"摩纳哥","abs":"MC","code":"377"},
  {"eng_name":"Moldova","name":"摩尔多瓦","abs":"MD","code":"373"},
  {"eng_name":"Montenegro","name":"黑山","abs":"ME","code":"382"},
  {"eng_name":"Madagascar","name":"马达加斯加","abs":"MG","code":"261"},
  {"eng_name":"Marshall Islands","name":"马绍尔群岛","abs":"MH","code":"692"},
  {"eng_name":"Macedonia","name":"马其顿","abs":"MK","code":"389"},
  {"eng_name":"Mali","name":"马里","abs":"ML","code":"223"},
  {"eng_name":"Myanmar","name":"缅甸","abs":"MM","code":"95"},
  {"eng_name":"Mongolia","name":"蒙古","abs":"MN","code":"976"},
  {"eng_name":"Macau","name":"中国澳门","abs":"MO","code":"853"},
  {"eng_name":"Mauritania","name":"毛里塔尼亚","abs":"MR","code":"222"},
  {"eng_name":"Montserrat","name":"蒙特塞拉特岛","abs":"MS","code":"1664"},
  {"eng_name":"Malta","name":"马耳他","abs":"MT","code":"356"},
  {"eng_name":"Mauritius","name":"毛里求斯","abs":"MU","code":"230"},
  {"eng_name":"Maldives","name":"马尔代夫","abs":"MV","code":"960"},
  {"eng_name":"Malawi","name":"马拉维","abs":"MW","code":"265"},
  {"eng_name":"Mexico","name":"墨西哥","abs":"MX","code":"52"},
  {"eng_name":"Malaysia","name":"马来西亚","abs":"MY","code":"60"},
  {"eng_name":"Mozambique","name":"莫桑比克","abs":"MZ","code":"258"},
  {"eng_name":"Namibia","name":"纳米比亚","abs":"NA","code":"264"},
  {"eng_name":"New Caledonia","name":"新喀里多尼亚","abs":"NC","code":"687"},
  {"eng_name":"Niger","name":"尼日尔","abs":"NE","code":"227"},
  {"eng_name":"Nigeria","name":"尼日利亚","abs":"NG","code":"234"},
  {"eng_name":"Nicaragua","name":"尼加拉瓜","abs":"NI","code":"505"},
  {"eng_name":"Netherlands","name":"荷兰","abs":"NL","code":"31"},
  {"eng_name":"Norway","name":"挪威","abs":"NO","code":"47"},
  {"eng_name":"Nepal","name":"尼泊尔","abs":"NP","code":"977"},
  {"eng_name":"Nauru","name":"拿鲁岛","abs":"NR","code":"674"},
  {"eng_name":"New Zealand","name":"新西兰","abs":"NZ","code":"64"},
  {"eng_name":"Oman","name":"阿曼","abs":"OM","code":"968"},
  {"eng_name":"Panama","name":"巴拿马","abs":"PA","code":"507"},
  {"eng_name":"Peru","name":"秘鲁","abs":"PE","code":"51"},
  {"eng_name":"French Polynesia","name":"法属波利尼西亚","abs":"PF","code":"689"},
  {"eng_name":"Papua New Guinea","name":"巴布亚新几内亚","abs":"PG","code":"675"},
  {"eng_name":"Philippines","name":"菲律宾","abs":"PH","code":"63"},
  {"eng_name":"Pakistan","name":"巴基斯坦","abs":"PK","code":"92"},
  {"eng_name":"Poland","name":"波兰","abs":"PL","code":"48"},
  {"eng_name":"Saint Pierreand Miquelon","name":"圣彼埃尔和密克隆岛","abs":"PM","code":"508"},
  {"eng_name":"Puerto Rico","name":"波多黎各","abs":"PR","code":"1787"},
  {"eng_name":"Portugal","name":"葡萄牙","abs":"PT","code":"351"},
  {"eng_name":"Palau","name":"帕劳","abs":"PW","code":"680"},
  {"eng_name":"Paraguay","name":"巴拉圭","abs":"PY","code":"595"},
  {"eng_name":"Qatar","name":"卡塔尔","abs":"QA","code":"974"},
  {"eng_name":"Réunion Island","name":"留尼汪","abs":"RE","code":"262"},
  {"eng_name":"Romania","name":"罗马尼亚","abs":"RO","code":"40"},
  {"eng_name":"Serbia","name":"塞尔维亚","abs":"RS","code":"381"},
  {"eng_name":"Russia","name":"俄罗斯","abs":"RU","code":"7"},
  {"eng_name":"Rwanda","name":"卢旺达","abs":"RW","code":"250"},
  {"eng_name":"Saudi Arabia","name":"沙特阿拉伯","abs":"SA","code":"966"},
  {"eng_name":"Solomon Islands","name":"所罗门群岛","abs":"SB","code":"677"},
  {"eng_name":"Seychelles","name":"塞舌尔","abs":"SC","code":"248"},
  {"eng_name":"Sudan","name":"苏丹","abs":"SD","code":"249"},
  {"eng_name":"Sweden","name":"瑞典","abs":"SE","code":"46"},
  {"eng_name":"Singapore","name":"新加坡","abs":"SG","code":"65"},
  {"eng_name":"Slovenia","name":"斯洛文尼亚","abs":"SI","code":"386"},
  {"eng_name":"Slovakia","name":"斯洛伐克","abs":"SK","code":"421"},
  {"eng_name":"Sierra Leone","name":"塞拉利昂","abs":"SL","code":"232"},
  {"eng_name":"San Marino","name":"圣马力诺","abs":"SM","code":"378"},
  {"eng_name":"Senegal","name":"塞内加尔","abs":"SN","code":"221"},
  {"eng_name":"Somalia","name":"索马里","abs":"SO","code":"252"},
  {"eng_name":"Suriname","name":"苏里南","abs":"SR","code":"597"},
  {"eng_name":"Sao Tome and Principe","name":"圣多美和普林西比","abs":"ST","code":"239"},
  {"eng_name":"ElSalvador","name":"萨尔瓦多","abs":"SV","code":"503"},
  {"eng_name":"Swaziland","name":"斯威士兰","abs":"SZ","code":"268"},
  {"eng_name":"Turksand Caicos Islands","name":"特克斯和凯科斯群岛","abs":"TC","code":"1649"},
  {"eng_name":"Chad","name":"乍得","abs":"TD","code":"235"},
  {"eng_name":"Togo","name":"多哥","abs":"TG","code":"228"},
  {"eng_name":"Thailand","name":"泰国","abs":"TH","code":"66"},
  {"eng_name":"Tajikistan","name":"塔吉克斯坦","abs":"TJ","code":"992"},
  {"eng_name":"East Timor","name":"东帝汶","abs":"TL","code":"670"},
  {"eng_name":"Turkmenistan","name":"土库曼斯坦","abs":"TM","code":"993"},
  {"eng_name":"Tunisia","name":"突尼斯","abs":"TN","code":"216"},
  {"eng_name":"Tonga","name":"汤加","abs":"TO","code":"676"},
  {"eng_name":"Turkey","name":"土耳其","abs":"TR","code":"90"},
  {"eng_name":"Trinidadand Tobago","name":"特立尼达和多巴哥","abs":"TT","code":"1868"},
  {"eng_name":"Taiwan","name":"中国台湾","abs":"TW","code":"886"},
  {"eng_name":"Chinese","name":"中国大陆","abs":"TW","code":"86"},
  {"eng_name":"Tanzania","name":"坦桑尼亚","abs":"TZ","code":"255"},
  {"eng_name":"Ukraine","name":"乌克兰","abs":"UA","code":"380"},
  {"eng_name":"Uganda","name":"乌干达","abs":"UG","code":"256"},
  {"eng_name":"United States","name":"美国","abs":"US","code":"1"},
  {"eng_name":"Uruguay","name":"乌拉圭","abs":"UY","code":"598"},
  {"eng_name":"Uzbekistan","name":"乌兹别克斯坦","abs":"UZ","code":"998"},
  {"eng_name":"Saint Vincent and The Grenadines","name":"圣文森特和格林纳丁斯","abs":"VC","code":"1784"},
  {"eng_name":"Venezuela","name":"委内瑞拉","abs":"VE","code":"58"},
  {"eng_name":"VirginIslands,British","name":"英属处女群岛","abs":"VG","code":"1284"},
  {"eng_name":"Vietnam","name":"越南","abs":"VN","code":"84"},
  {"eng_name":"Vanuatu","name":"瓦努阿图","abs":"VU","code":"678"},
  {"eng_name":"Samoa","name":"萨摩亚","abs":"WS","code":"685"},
  {"eng_name":"Yemen","name":"也门","abs":"YE","code":"967"},
  {"eng_name":"Mayotte","name":"马约特","abs":"YT","code":"269"},
  {"eng_name":"South Africa","name":"南非","abs":"ZA","code":"27"},
  {"eng_name":"Zambia","name":"赞比亚","abs":"ZM","code":"260"},
  {"eng_name":"Zimbabwe","name":"津巴布韦","abs":"ZW","code":"263"}
]

export default COUNTRY_CODE.sort((a, b) => a.code - b.code)
